var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{on:{"click":function($event){_vm.isActive = !_vm.isActive},"mouse-over":function($event){_vm.isActive = true}}},[_vm._v(" Categories ")]),(_vm.isActive)?_c('CategoriesMenu',{attrs:{"categories":_vm.formattedCategories},on:{"select":_vm.categorySelected}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }